module.exports = __webpack_public_path__ + "img/scalability-5.25457c1d.png";